import * as links from '../static data/sociallinks'

export default function SocialLinks(){

    return(
        <div className="social-links">
            {links.links.map(l=>
                <a href={l.link} target="_blank">
                <div>
                    <img className={"icon-size-" + l.size} src={l.image}/>
                </div>
                </a>
            )}            
        </div>
    )
}
